import {IElement} from '../../../incase-domain/elements';
import {ELEMENT} from '../../../incase-domain/elements/base/ElementTypes';
import {getEmptyElement} from '../../element';

function generateHtmlCoverTemplate(slideId: string): IElement[] {
    return [
        {
            ...getEmptyElement(slideId, ELEMENT.HTML),
            name: 'HTML',
            coverSlide: true,
            fitContent: false,
            xPosition: 0,
            yPosition: 0,
            width: '100%',
            height: '100%',
        },
    ];
}

export default generateHtmlCoverTemplate;
